import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Index from "@/pages/Index";
import { redirects } from "@/lib/catalog";
import { HUB_PATHS } from "@/lib/site";

const SeoLandingPage = lazy(() => import("@/pages/SeoLandingPage"));
const PerfumeAnaCastela = lazy(() => import("@/pages/PerfumeAnaCastela"));
const CronogramaCapilar = lazy(() => import("@/pages/CronogramaCapilar"));
const TimetrosAntiqueda = lazy(() => import("@/pages/TimetrosAntiqueda"));
const OleoMirra = lazy(() => import("@/pages/OleoMirra"));
const SoroVello = lazy(() => import("@/pages/SoroVello"));
const ProgressivaFashionGold = lazy(() => import("@/pages/ProgressivaFashionGold"));
const ProductPage = lazy(() => import("@/pages/ProductPage"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const SEO_SHELL_PATHS = [
  HUB_PATHS.progressivaOficial,
  "/semana-do-crescimentooferta-100timetros-antiqueda-capilar-fashion-gold/",
];

const LEGAL_PATHS = ["/reembolso_devolucoes/", "/politica-de-privacidade/"];

function PageFallback() {
  return <div className="min-h-screen bg-background" role="status" aria-live="polite" aria-label="Carregando página" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path={HUB_PATHS.perfume} element={<PerfumeAnaCastela />} />
          <Route
            path={HUB_PATHS.perfume.replace(/\/$/, "")}
            element={<Navigate to={HUB_PATHS.perfume} replace />}
          />
          <Route path={HUB_PATHS.cronograma} element={<CronogramaCapilar />} />
          <Route
            path={HUB_PATHS.cronograma.replace(/\/$/, "")}
            element={<Navigate to={HUB_PATHS.cronograma} replace />}
          />
          <Route path={HUB_PATHS.antiqueda} element={<TimetrosAntiqueda />} />
          <Route
            path={HUB_PATHS.antiqueda.replace(/\/$/, "")}
            element={<Navigate to={HUB_PATHS.antiqueda} replace />}
          />
          <Route path={HUB_PATHS.oleoMirra} element={<OleoMirra />} />
          <Route
            path={HUB_PATHS.oleoMirra.replace(/\/$/, "")}
            element={<Navigate to={HUB_PATHS.oleoMirra} replace />}
          />
          <Route path={HUB_PATHS.soroVello} element={<SoroVello />} />
          <Route
            path={HUB_PATHS.soroVello.replace(/\/$/, "")}
            element={<Navigate to={HUB_PATHS.soroVello} replace />}
          />
          <Route path={HUB_PATHS.progressiva} element={<ProgressivaFashionGold />} />
          <Route
            path={HUB_PATHS.progressiva.replace(/\/$/, "")}
            element={<Navigate to={HUB_PATHS.progressiva} replace />}
          />
          {SEO_SHELL_PATHS.map((path) => (
            <Route key={path} path={path} element={<SeoLandingPage />} />
          ))}
          {SEO_SHELL_PATHS.map((path) => (
            <Route
              key={`${path}-noslash`}
              path={path.replace(/\/$/, "")}
              element={<Navigate to={path} replace />}
            />
          ))}
          {LEGAL_PATHS.map((path) => (
            <Route key={path} path={path} element={<LegalPage />} />
          ))}
          {LEGAL_PATHS.map((path) => (
            <Route
              key={`${path}-noslash`}
              path={path.replace(/\/$/, "")}
              element={<Navigate to={path} replace />}
            />
          ))}
          <Route path="/agencia-de-marketing/" element={<Navigate to="/" replace />} />
          <Route path="/agencia-de-marketing" element={<Navigate to="/" replace />} />
          {redirects.flatMap((redirect) => [
            <Route
              key={redirect.from}
              path={redirect.from}
              element={<Navigate to={redirect.to} replace />}
            />,
            <Route
              key={`${redirect.from}-noslash`}
              path={redirect.from.replace(/\/$/, "")}
              element={<Navigate to={redirect.to} replace />}
            />,
          ])}
          <Route path="/produto/:slug/" element={<ProductPage />} />
          <Route path="/produto/:slug" element={<ProductPage />} />
          <Route path="/loja-fashion-gold-oficial/" element={<Navigate to="/" replace />} />
          <Route path="/carrinho/" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
